import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import prepareAuthHeaders from "@utils/prepareAuthHeaders";
import { PushToken } from '@models/push-token';

const BASE_API_URL = process.env.REACT_APP_API_URL;

export interface PushTokenDelete {
  token: string;
}

export const pushTokenApi = createApi({
  reducerPath: "pushTokenApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${BASE_API_URL}/push-tokens`,
    prepareHeaders: prepareAuthHeaders,
  }),
  tagTypes: ["PushToken"],
  endpoints: (builder) => ({
    registerPushToken: builder.mutation<PushToken, Partial<PushToken>>({
      invalidatesTags: ["PushToken"],
      query: (body) => {
        return {
          url: "",
          method: "POST",
          body,
        };
      },
    }),
    deletePushToken: builder.mutation<
      PushToken,
      PushTokenDelete
    >({
      invalidatesTags: ["PushToken"],
      query: (body) => {
        return {
          url: "",
          method: "DELETE",
          body,
        };
      },
    }),
  }),
});

export const {
  useRegisterPushTokenMutation,
  useDeletePushTokenMutation,
} = pushTokenApi;
